export default "__VITE_ASSET__CyVHcHZO__"